var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4997 16.6667H19.1663V18.3333H0.833008V16.6667H2.49967V2.5C2.49967 2.27899 2.58747 2.06702 2.74375 1.91074C2.90003 1.75446 3.11199 1.66667 3.33301 1.66667H16.6663C16.8874 1.66667 17.0993 1.75446 17.2556 1.91074C17.4119 2.06702 17.4997 2.27899 17.4997 2.5V16.6667ZM15.833 16.6667V3.33333H4.16634V16.6667H15.833ZM6.66634 9.16667H9.16634V10.8333H6.66634V9.16667ZM6.66634 5.83333H9.16634V7.5H6.66634V5.83333ZM6.66634 12.5H9.16634V14.1667H6.66634V12.5ZM10.833 12.5H13.333V14.1667H10.833V12.5ZM10.833 9.16667H13.333V10.8333H10.833V9.16667ZM10.833 5.83333H13.333V7.5H10.833V5.83333Z",
    fill: "#2E6865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingSelect);
export default __webpack_public_path__ + "static/media/building_select.0f74d51d80ddb774b56017fda732c2c7.svg";
export { ForwardRef as ReactComponent };